import { useCallback } from 'react';
import { useQuickSearchModal } from '../../../shared/contexts';
import { getActiveListItemDetails } from '../../utils';
import { AssetItemDetail, ProjectItemDetail } from './components';

type QuickSearchItemDetailProps = {
  focusedKey: string | null;
} & Pick<React.ComponentProps<typeof AssetItemDetail>, 'onScroll'>;

export function QuickSearchItemDetail({
  focusedKey,
  onScroll,
}: QuickSearchItemDetailProps) {
  const { closeModal } = useQuickSearchModal();

  const { itemType } = getActiveListItemDetails(
    focusedKey ? String(focusedKey) : null
  );

  const handleNavigate = useCallback(
    (href: string) => closeModal({ navigatingTo: href }),
    [closeModal]
  );

  switch (itemType) {
    case 'AssetResult':
      return (
        <AssetItemDetail
          focusedKey={focusedKey}
          onNavigate={handleNavigate}
          onScroll={onScroll}
        />
      );
    case 'ProjectResult':
      return (
        <ProjectItemDetail
          focusedKey={focusedKey}
          onNavigate={handleNavigate}
          onScroll={onScroll}
        />
      );
    default:
      return null;
  }
}
